import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=4c8c6c60&scoped=true&"
import script from "./Authorize.vue?vue&type=script&lang=js&"
export * from "./Authorize.vue?vue&type=script&lang=js&"
import style0 from "./Authorize.vue?vue&type=style&index=0&id=4c8c6c60&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c6c60",
  null
  
)

export default component.exports